import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import c from 'classnames';

import styles from './THCheckbox.module.css';

type CheckboxProps = {
  label: React.ReactNode;
  disabled?: boolean;
  value?: string;
  defaultChecked?: boolean;
  classes?: string;
} & UseFormRegisterReturn;

const THCheckbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ name, value, label, classes, defaultChecked, ...rest }, ref) => {
    return (
      <label
        htmlFor={`${name}-${value}`}
        className={c(styles.container, classes)}
      >
        {label}
        <input
          id={`${name}-${value}`}
          name={name}
          value={value}
          checked={defaultChecked}
          type='checkbox'
          {...rest} // { onChange, onBlur }
          ref={ref}
        />
        <span className={styles.checkmark}></span>
      </label>
    );
  },
);
THCheckbox.displayName = 'THCheckbox';
export default THCheckbox;
